/**
 * Game-agnostic DOM helpers shared by every JPJ game.
 *
 * Module scripts run after the document is parsed, so `getElementById` is safe
 * to call at import time for IDs present in the static markup.
 */

/** Typed `getElementById`. The caller asserts the element exists. */
export const $ = <T extends HTMLElement = HTMLElement>(id: string): T =>
  document.getElementById(id) as T;

/**
 * Overlays are shown/hidden by toggling the shared `.hidden` class (the CSS in
 * every game maps `.overlay.hidden` to `display:none`). These helpers keep that
 * convention in one place instead of repeating `classList.add/remove("hidden")`.
 */
export const showOverlay = (id: string): void => $(id).classList.remove("hidden");
export const hideOverlay = (id: string): void => $(id).classList.add("hidden");
export const isOverlayOpen = (id: string): boolean => !$(id).classList.contains("hidden");
